import React from "react";

export const TableSkeleton = ({ className = "" }) => (
  <div
    className={`w-full h-6 rounded-md my-2 bg-gray-200 dark:bg-gray-700 animate-pulse ${className}`}
  ></div>
);
